// src/views/Users/Customers/Modal/AddProjectModal.jsx
import { useState, useEffect, useRef } from "react";
import { globalConstants, modeConstants } from "../../../constants";
import ActionsDataTable from "../../../shared/DataTable/ActionsDataTable";
import { useNavigate } from "react-router-dom";
import AddCandidateModal from "../../../shared/Modals/CandidateModal";
import ViewAllCandidatesModal from "../../../shared/Modals/ViewAllCandidatesModal";
import { useDispatch, useSelector } from "react-redux";
import {
  candidateActions,
  companyActions,
  projectActions,
  recruiterActions,
  screenActions,
} from "../../../redux/actions";
import AddProjectModal from "../../../shared/Modals/ProjectModal";
import { getUserData, SCREENS_IDS } from "../../../system";
import UploadExcelModal from "../../../shared/Modals/UploadExcelModal";
import CompanyModal from '../Customers/Modal/CompanyModal';

export default function AssignedRecruiterProjects() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const allData = useSelector((s) => s.recruiterReducer.assignedProjects);
  const profileData = useSelector((s) => s.userReducer.profileData);
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showAddProject, setShowAddProject] = useState(false);
  const [showAddCan, setShowAddCan] = useState(false);
  const [showViewCan, setShowViewCan] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [companyModal, setCompanyModal] = useState(false);

  const actions =
  {
    name: "Actions",
    sortable: false,
    width: "170px",
    cell: (row) => (
      <div
        className="d-flex align-items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          title="View"
          aria-label="View"
          onClick={() => {
            getRowData(row, modeConstants.VIEW_MODE);
            dispatch(companyActions.getCompanyById(row.companyId));
            setShowAddProject(true);
          }}
        >
          <i className="bi bi-eye" />
        </button>

        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="More"
          >
            <i className="bi bi-three-dots-vertical" />
          </button>
          <ul
            className="dropdown-menu dropdown-menu-end"
            onClick={(e) => e.stopPropagation()}
          >
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  getRowData(row, modeConstants.ADD_MODE);
                  setShowAddCan(true);
                }}
              >
                <i className="bi bi-plus-circle me-2" /> Add Candidate
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  getCandidateByProjectId(row, modeConstants.ADD_MODE);
                  setShowViewCan(true);
                }}
              >
                <i className="bi bi-collection me-2" /> View Candidates
              </button>
            </li>
            <li>
              <a
                href={
                  process.env.REACT_APP_STORAGE_URL + "recruiterTemplate.xlsx"
                }
              >
                <button className="dropdown-item">
                  <i className="bi bi-download me-2" />
                  Template
                </button>
              </a>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  getyProjectById(row, modeConstants.ADD_MODE);
                  setShowUpload(true);
                }}
              >
                <i className="bi bi-upload me-2" />
                Upload
              </button>
            </li>
          </ul>
        </div>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  };
  const getRowData = (row, nextMode) => {
    dispatch(projectActions.getProjectById(row.id));
    setMode(nextMode);
  };

  const getCandidateByProjectId = (row, nextMode) => {
    dispatch(projectActions.getProjectById(row.id));
    dispatch(candidateActions.getAllCandidate(initialGridState, row.id));
    setMode(nextMode);
  };

  const getyProjectById = (row, nextMode) => {
    dispatch(projectActions.getProjectById(row.id));
    setMode(nextMode);
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    const decryptedData = getUserData();
    dispatch(
      recruiterActions.getAllAssignedProjects(gridState, decryptedData.id)
    );
  };

  const openModal = (row) => {
    dispatch(companyActions.getCompanyById(row.companyId));
    setCompanyModal(true);
  }

  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    dispatch(companyActions.getAllCompanyList());
    dispatch(recruiterActions.getAllRecruiterList());
  }, []);

  useEffect(() => {
    if (!showViewCan) {
      dispatch(screenActions.getColumnsByScreenId(SCREENS_IDS.ASSIGNED_PROJECTS));
      dispatch(screenActions.getUserPreferencesByScreenId(SCREENS_IDS.ASSIGNED_PROJECTS));
    }
  }, [showViewCan]);

  return (
    <>
      <AddProjectModal
        show={showAddProject}
        onHide={() => setShowAddProject(false)}
        mode={mode}
      />

      <AddCandidateModal
        show={showAddCan}
        onHide={() => setShowAddCan(false)}
        mode={mode}
      />

      {showViewCan ? (
        <ViewAllCandidatesModal
          show={showViewCan}
          onHide={() => setShowViewCan(false)}
          company={selectedRow}
        />
      ) : ""}
      {
        companyModal?
        <CompanyModal
                  showModal={companyModal}
                  setShowModal={() => setCompanyModal(false)}
                  mode={modeConstants.VIEW_MODE}
                />
        :""
      }
      <UploadExcelModal
        show={showUpload}
        onHide={() => setShowUpload(false)}
        isRecruiter={true}
      />

      <ActionsDataTable
        actions={actions}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setMode={setMode}
        setShowModal={setShowAddProject}
        allowCreation={false}
        setGridState={setGridState}
        sortServer={true}
        screenId={SCREENS_IDS.ASSIGNED_PROJECTS}
        openModal={openModal}
      />
    </>
  );
}
